/** Web push VAPID key: Firebase Console → Project settings → Cloud Messaging → Web configuration. */
const FIREBASE_WEB_VAPID_KEY =
  'BMBYvpTwp-TdbA6X2hld88YYD8EVSCI1QGFP-M8zaSl83mQ-yZBzdwwoWpNAG4cNNODisnDBL66SpAMbfzJ5Sk0';

export const environment = {
  production: true,
  BASEURL: 'https://nest-backend.martinsbbqadmin.com/',
  firebaseConfig: {
    apiKey: 'AIzaSyAdbzj__U1vQmV-YmkEAD4s8NaC37vnwe4',
    authDomain: 'martinbbqtesting.firebaseapp.com',
    projectId: 'martinbbqtesting',
    storageBucket: 'martinbbqtesting.firebasestorage.app',
    messagingSenderId: '365936828150',
    appId: '1:365936828150:web:22afd309d68794f76d56d7',
    measurementId: 'G-M64BBGB8P1',
    vapidKey: FIREBASE_WEB_VAPID_KEY,
  },
};
